export default __webpack_public_path__ + "static/media/show.c964d844.png";